window.Products.DeviceCase.Iphone6 = function() {
};
window.Products.DeviceCase.Iphone6.inherits(window.Products.DeviceCase.DeviceCase);
window.Products.DeviceCase.Iphone6.id = 26;
window.Products.DeviceCase.Iphone6.slug = 'iphone6';

window.Products.DeviceCase.Iphone6.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = -0.65;
	modelViewer.camera.position.z = 8;
};

window.Products.DeviceCase.Iphone6.prototype.setThreeControls = function(controls) {
	controls.minDistance = 3;
	controls.maxDistance = 4;
};